import { colors } from './colors';

/**
 * A code syntax highlighting theme for use with Shiki: https://shiki.style/guide/load-theme
 */
export const dark = {
    colors: {
        'activityBar.background': colors.slate[950],
        'activityBar.border': colors.slate[950],
        'activityBar.foreground': colors.slate[500],
        'activityBar.inactiveForeground': colors.slate[700],
        'activityBarBadge.background': colors.blue[600],
        'activityBarBadge.foreground': colors.white,
        'activityBarTop.foreground': colors.slate[500],
        'activityBarTop.inactiveForeground': colors.slate[700],
        'badge.background': `${colors.blue[500]}30`,
        'badge.foreground': colors.slate[300],
        'breadcrumb.activeSelectionForeground': colors.slate[200],
        'breadcrumb.background': colors.slate[950],
        'breadcrumb.focusForeground': colors.slate[200],
        'breadcrumb.foreground': colors.slate[600],
        'breadcrumbPicker.background': colors.slate[950],
        'button.background': `${colors.blue[600]}dd`,
        'button.foreground': colors.white,
        'button.hoverBackground': `${colors.blue[600]}aa`,
        'button.secondaryBackground': colors.slate[700],
        'charts.blue': colors.blue[400],
        'charts.foreground': colors.slate[400],
        'charts.green': colors.cyan[500],
        'charts.lines': colors.slate[950],
        'charts.orange': colors.orange[400],
        'charts.purple': colors.purple[400],
        'charts.red': colors.red[400],
        'charts.yellow': colors.yellow[400],
        'chat.avatarBackground': colors.blue[600],
        'chat.avatarForeground': colors.slate[200],
        'chat.requestBorder': colors.slate[900],
        'chat.slashCommandBackground': colors.slate[900],
        'chat.slashCommandForeground': colors.blue[400],
        'debugConsole.errorForeground': colors.red[400],
        'debugConsole.infoForeground': colors.slate[500],
        'debugConsole.sourceForeground': colors.slate[500],
        'debugConsole.warningForeground': colors.yellow[500],
        'debugConsoleInputIcon.foreground': colors.green[400],
        'debugExceptionWidget.background': colors.slate[900],
        'debugExceptionWidget.border': colors.red[700],
        'debugIcon.breakpointDisabledForeground': colors.slate[600],
        'debugIcon.breakpointForeground': colors.red[500],
        'debugIcon.breakpointUnverifiedForeground': colors.red[600],
        'debugTokenExpression.boolean': colors.orange[400],
        'debugTokenExpression.error': colors.red[400],
        'debugTokenExpression.name': colors.cyan[400],
        'debugTokenExpression.number': colors.orange[400],
        'debugTokenExpression.string': colors.green[400],
        'debugTokenExpression.value': colors.slate[400],
        'debugToolBar.background': colors.slate[900],
        'debugView.stateLabelBackground': colors.slate[900],
        'debugView.stateLabelForeground': colors.slate[500],
        'debugView.valueChangedHighlight': `${colors.blue[600]}aa`,
        descriptionForeground: colors.slate[600],
        'diffEditor.diagonalFill': colors.slate[700],
        'diffEditor.insertedLineBackground': `${colors.cyan[500]}20`,
        'diffEditor.insertedTextBackground': `${colors.cyan[500]}20`,
        'diffEditor.removedLineBackground': `${colors.red[500]}22`,
        'diffEditor.removedTextBackground': `${colors.red[500]}22`,
        'diffEditor.unchangedCodeBackground': `${colors.slate[700]}66`,
        'diffEditorGutter.insertedLineBackground': `${colors.cyan[500]}25`,
        'diffEditorGutter.removedLineBackground': `${colors.red[500]}22`,
        'diffEditorOverview.insertedForeground': `${colors.cyan[500]}25`,
        'diffEditorOverview.removedForeground': `${colors.red[500]}22`,
        disabledForeground: colors.slate[600],
        'dropdown.background': colors.slate[900],
        'dropdown.foreground': colors.slate[500],
        'dropdown.listBackground': colors.slate[900],
        'editor.background': colors.slate[950],
        'editor.findMatchBackground': `${colors.blue[600]}66`,
        'editor.findMatchBorder': colors.yellow[500],
        'editor.findMatchHighlightBackground': `${colors.blue[600]}66`,
        'editor.findRangeHighlightBackground': `${colors.slate[600]}33`,
        'editor.focusedStackFrameHighlightBackground': `${colors.green[400]}20`,
        'editor.foldBackground': `${colors.slate[950]}4a`,
        'editor.foreground': colors.slate[200],
        'editor.inactiveSelectionBackground': `${colors.slate[600]}25`,
        'editor.lineHighlightBackground': colors.slate[800],
        'editor.rangeHighlightBackground': `${colors.slate[600]}20`,
        'editor.selectionBackground': `${colors.slate[600]}4d`,
        'editor.selectionHighlightBackground': `${colors.slate[600]}44`,
        'editor.stackFrameHighlightBackground': `${colors.yellow[500]}20`,
        'editor.wordHighlightBackground': `${colors.slate[600]}44`,
        'editor.wordHighlightStrongBackground': `${colors.slate[600]}55`,
        'editorBracketHighlight.foreground1': colors.blue[400],
        'editorBracketHighlight.foreground2': colors.cyan[400],
        'editorBracketHighlight.foreground3': colors.purple[400],
        'editorBracketHighlight.foreground4': colors.cyan[500],
        'editorBracketHighlight.foreground5': colors.green[500],
        'editorBracketHighlight.foreground6': colors.yellow[500],
        'editorBracketHighlight.unexpectedBracket.foreground': colors.red[500],
        'editorBracketMatch.background': colors.slate[950],
        'editorBracketMatch.border': colors.slate[600],
        'editorBracketPairGuide.activeBackground1': colors.blue[400],
        'editorBracketPairGuide.activeBackground2': colors.cyan[400],
        'editorBracketPairGuide.activeBackground3': colors.purple[400],
        'editorBracketPairGuide.activeBackground4': colors.cyan[500],
        'editorBracketPairGuide.activeBackground5': colors.green[500],
        'editorBracketPairGuide.activeBackground6': colors.yellow[500],
        'editorCodeLens.foreground': colors.slate[600],
        'editorCursor.foreground': colors.slate[200],
        'editorError.foreground': colors.red[500],
        'editorGhostText.foreground': colors.slate[500],
        'editorGroup.border': colors.slate[900],
        'editorGroup.dropBackground': colors.slate[800],
        'editorGroupHeader.border': colors.slate[900],
        'editorGroupHeader.noTabsBackground': colors.slate[950],
        'editorGroupHeader.tabsBackground': colors.slate[950],
        'editorGroupHeader.tabsBorder': colors.slate[900],
        'editorGutter.addedBackground': colors.green[900],
        'editorGutter.deletedBackground': colors.red[900],
        'editorGutter.modifiedBackground': colors.blue[900],
        'editorHint.foreground': colors.cyan[500],
        'editorHoverWidget.background': colors.slate[950],
        'editorHoverWidget.border': colors.slate[900],
        'editorIndentGuide.activeBackground1': colors.slate[600],
        'editorIndentGuide.background1': colors.slate[800],
        'editorInfo.foreground': colors.cyan[500],
        'editorInlayHint.foreground': colors.slate[500],
        'editorLightBulb.foreground': colors.yellow[500],
        'editorLightBulbAutoFix.foreground': colors.yellow[500],
        'editorLineNumber.activeForeground': colors.slate[500],
        'editorLineNumber.foreground': colors.slate[600],
        'editorLink.activeForeground': colors.slate[300],
        'editorMarkerNavigation.background': colors.slate[950],
        'editorOverviewRuler.addedForeground': colors.green[900],
        'editorOverviewRuler.border': colors.slate[900],
        'editorOverviewRuler.bracketMatchForeground': colors.slate[900],
        'editorOverviewRuler.deletedForeground': colors.red[800],
        'editorOverviewRuler.errorForeground': colors.red[500],
        'editorOverviewRuler.findMatchForeground': `${colors.slate[200]}44`,
        'editorOverviewRuler.infoForeground': colors.cyan[500],
        'editorOverviewRuler.modifiedForeground': colors.blue[800],
        'editorOverviewRuler.rangeHighlightForeground': `${colors.slate[200]}44`,
        'editorOverviewRuler.selectionHighlightForeground': `${colors.slate[200]}22`,
        'editorOverviewRuler.warningForeground': colors.yellow[500],
        'editorOverviewRuler.wordHighlightForeground': `${colors.purple[400]}55`,
        'editorOverviewRuler.wordHighlightStrongForeground': `${colors.purple[400]}66`,
        'editorPane.background': colors.slate[900],
        'editorRuler.foreground': colors.slate[900],
        'editorSuggestWidget.background': colors.slate[950],
        'editorSuggestWidget.border': colors.slate[900],
        'editorSuggestWidget.highlightForeground': colors.blue[400],
        'editorSuggestWidget.selectedBackground': colors.slate[800],
        'editorWarning.foreground': colors.yellow[500],
        'editorWhitespace.foreground': colors.slate[600],
        'editorWidget.background': colors.slate[950],
        'editorWidget.border': colors.slate[900],
        'editorWidget.foreground': colors.slate[500],
        'editorWidget.resizeBorder': `${colors.slate[600]}33`,
        errorForeground: colors.slate[600],
        'extensionBadge.remoteBackground': colors.blue[600],
        'extensionBadge.remoteForeground': colors.white,
        'extensionButton.prominentBackground': `${colors.blue[600]}dd`,
        'extensionButton.prominentForeground': colors.white,
        'extensionButton.prominentHoverBackground': `${colors.blue[600]}aa`,
        focusBorder: `${colors.slate[600]}33`,
        foreground: colors.slate[500],
        'gitDecoration.addedResourceForeground': colors.cyan[500],
        'gitDecoration.conflictingResourceForeground': `${colors.yellow[500]}cc`,
        'gitDecoration.deletedResourceForeground': colors.red[600],
        'gitDecoration.ignoredResourceForeground': colors.slate[600],
        'gitDecoration.modifiedResourceForeground': colors.blue[400],
        'gitDecoration.renamedResourceForeground': colors.cyan[500],
        'gitDecoration.stageDeletedResourceForeground': colors.red[600],
        'gitDecoration.stageModifiedResourceForeground': colors.blue[400],
        'gitDecoration.untrackedResourceForeground': colors.cyan[500],
        'gitlens.gutterBackgroundColor': colors.slate[950],
        'gitlens.gutterForegroundColor': colors.slate[500],
        'gitlens.gutterUncommittedForegroundColor': colors.blue[400],
        'gitlens.trailingLineForegroundColor': colors.slate[500],
        'icon.foreground': colors.slate[500],
        'inlineChat.foreground': colors.slate[200],
        'inlineChatDiff.inserted': `${colors.cyan[500]}40`,
        'inlineChatDiff.removed': `${colors.red[500]}42`,
        'inlineChatInput.background': colors.slate[900],
        'input.background': colors.slate[900],
        'input.border': colors.slate[900],
        'input.foreground': colors.slate[200],
        'input.placeholderForeground': `${colors.slate[500]}8A`,
        'inputOption.activeBackground': `${colors.blue[600]}44`,
        'inputOption.activeForeground': colors.slate[200],
        'inputValidation.errorBackground': colors.red[900],
        'inputValidation.errorBorder': colors.red[700],
        'inputValidation.errorForeground': colors.slate[200],
        'inputValidation.infoBackground': `${colors.blue[600]}5c`,
        'inputValidation.infoBorder': colors.blue[600],
        'inputValidation.infoForeground': colors.slate[200],
        'inputValidation.warningBackground': colors.yellow[600],
        'inputValidation.warningBorder': colors.yellow[500],
        'inputValidation.warningForeground': colors.black,
        'list.activeSelectionBackground': colors.slate[800],
        'list.activeSelectionForeground': colors.slate[200],
        'list.deemphasizedForeground': colors.slate[500],
        'list.dropBackground': colors.slate[800],
        'list.errorForeground': colors.red[400],
        'list.focusBackground': colors.slate[800],
        'list.focusForeground': colors.slate[200],
        'list.highlightForeground': colors.blue[400],
        'list.hoverBackground': colors.slate[900],
        'list.hoverForeground': colors.slate[200],
        'list.inactiveSelectionBackground': colors.slate[800],
        'list.inactiveSelectionForeground': colors.slate[200],
        'list.invalidItemForeground': colors.orange[600],
        'list.warningForeground': colors.yellow[500],
        'listFilterWidget.background': colors.slate[900],
        'listFilterWidget.noMatchesOutline': colors.red[700],
        'listFilterWidget.outline': colors.blue[600],
        'menu.background': colors.slate[950],
        'menu.border': colors.slate[900],
        'menu.foreground': colors.slate[500],
        'menu.selectionBackground': colors.slate[800],
        'menu.selectionForeground': colors.slate[200],
        'menu.separatorBackground': colors.slate[900],
        'menubar.selectionBackground': colors.slate[800],
        'menubar.selectionBorder': colors.slate[800],
        'menubar.selectionForeground': colors.slate[200],
        'merge.currentContentBackground': `${colors.cyan[700]}44`,
        'merge.currentHeaderBackground': `${colors.cyan[500]}25`,
        'merge.incomingContentBackground': `${colors.blue[600]}44`,
        'merge.incomingHeaderBackground': `${colors.blue[600]}aa`,
        'mergeEditor.change.background': `${colors.cyan[500]}25`,
        'mergeEditor.change.word.background': `${colors.cyan[500]}40`,
        'mergeEditor.conflict.handled.minimapOverViewRuler': colors.cyan[500],
        'mergeEditor.conflict.handledFocused.border': `${colors.cyan[500]}65`,
        'mergeEditor.conflict.handledUnfocused.border': `${colors.cyan[500]}25`,
        'mergeEditor.conflict.unhandled.minimapOverViewRuler':
            colors.yellow[500],
        'mergeEditor.conflict.unhandledFocused.border': `${colors.yellow[500]}b0`,
        'mergeEditor.conflict.unhandledUnfocused.border': `${colors.yellow[500]}88`,
        'minimapGutter.addedBackground': colors.green[900],
        'minimapGutter.deletedBackground': colors.red[900],
        'minimapGutter.modifiedBackground': colors.blue[900],
        'multiDiffEditor.border': colors.slate[900],
        'multiDiffEditor.headerBackground': colors.slate[900],
        'notebook.cellBorderColor': colors.slate[900],
        'notebook.cellEditorBackground': colors.slate[950],
        'notebook.cellStatusBarItemHoverBackground': colors.slate[800],
        'notebook.editorBackground': colors.slate[900],
        'notebook.focusedCellBorder': colors.blue[800],
        'notificationCenterHeader.background': colors.slate[900],
        'notificationLink.foreground': colors.blue[400],
        'notifications.background': colors.slate[900],
        'notificationsErrorIcon.foreground': colors.red[400],
        'notificationsInfoIcon.foreground': colors.cyan[500],
        'notificationsWarningIcon.foreground': colors.yellow[400],
        'panel.background': colors.slate[950],
        'panel.border': colors.slate[900],
        'panelInput.border': colors.slate[950],
        'panelTitle.activeBorder': colors.slate[950],
        'panelTitle.activeForeground': colors.slate[500],
        'panelTitle.inactiveForeground': colors.slate[600],
        'peekView.border': colors.slate[900],
        'peekViewEditor.background': colors.slate[950],
        'peekViewEditor.matchHighlightBackground': `${colors.blue[600]}66`,
        'peekViewResult.background': colors.slate[900],
        'peekViewResult.fileForeground': colors.slate[500],
        'peekViewResult.lineForeground': colors.slate[200],
        'peekViewResult.matchHighlightBackground': `${colors.blue[600]}66`,
        'peekViewResult.selectionBackground': `${colors.blue[600]}33`,
        'peekViewResult.selectionForeground': colors.slate[200],
        'peekViewTitle.background': colors.slate[900],
        'peekViewTitleDescription.foreground': colors.slate[500],
        'peekViewTitleLabel.foreground': colors.slate[200],
        'pickerGroup.border': colors.slate[900],
        'pickerGroup.foreground': colors.slate[200],
        'progressBar.background': colors.blue[600],
        'sash.hoverBorder': colors.blue[800],
        'scmGraph.foreground1': colors.orange[400],
        'scmGraph.foreground2': colors.yellow[500],
        'scmGraph.foreground3': colors.cyan[500],
        'scmGraph.foreground4': colors.blue[400],
        'scmGraph.foreground5': colors.purple[400],
        'scmGraph.historyItemBaseRefColor': colors.purple[400],
        'scmGraph.historyItemHoverAdditionsForeground': colors.cyan[500],
        'scmGraph.historyItemHoverDefaultLabelForeground': colors.slate[200],
        'scmGraph.historyItemHoverDeletionsForeground': colors.red[400],
        'scmGraph.historyItemHoverLabelForeground': colors.slate[800],
        'scmGraph.historyItemRefColor': colors.blue[500],
        'scmGraph.historyItemRemoteRefColor': colors.cyan[500],
        'scrollbar.shadow': `${colors.black}33`,
        'scrollbarSlider.activeBackground': `${colors.slate[400]}22`,
        'scrollbarSlider.background': `${colors.slate[400]}15`,
        'scrollbarSlider.hoverBackground': `${colors.slate[400]}10`,
        'selection.background': `${colors.slate[600]}40`,
        'settings.headerForeground': colors.blue[400],
        'sideBar.background': colors.slate[950],
        'sideBar.border': colors.slate[900],
        'sideBar.dropBackground': colors.slate[800],
        'sideBar.foreground': colors.slate[500],
        'sideBarSectionHeader.background': colors.slate[950],
        'sideBarSectionHeader.border': colors.slate[900],
        'sideBarSectionHeader.foreground': colors.slate[200],
        'sideBarTitle.foreground': colors.slate[500],
        'statusBar.background': colors.slate[950],
        'statusBar.border': colors.slate[900],
        'statusBar.debuggingBackground': colors.slate[950],
        'statusBar.debuggingForeground': colors.slate[500],
        'statusBar.foreground': colors.slate[500],
        'statusBar.noFolderBackground': colors.slate[950],
        'statusBarItem.activeBackground': colors.slate[900],
        'statusBarItem.hoverBackground': colors.slate[800],
        'statusBarItem.prominentBackground': colors.slate[900],
        'statusBarItem.prominentHoverBackground': colors.slate[800],
        'tab.activeBackground': colors.slate[950],
        'tab.activeBorder': colors.blue[600],
        'tab.activeForeground': colors.slate[200],
        'tab.activeModifiedBorder': colors.slate[900],
        'tab.border': colors.slate[900],
        'tab.hoverForeground': colors.slate[200],
        'tab.inactiveBackground': colors.slate[950],
        'tab.inactiveForeground': colors.slate[500],
        'tab.inactiveModifiedBorder': colors.slate[800],
        'tab.lastPinnedBorder': colors.slate[800],
        'tab.unfocusedActiveBorder': colors.slate[800],
        'tab.unfocusedActiveForeground': colors.slate[200],
        'tab.unfocusedHoverForeground': colors.slate[200],
        'tab.unfocusedInactiveForeground': colors.slate[500],
        'terminal.ansiBlack': colors.slate[600],
        'terminal.ansiBlue': colors.blue[400],
        'terminal.ansiBrightBlack': colors.slate[600],
        'terminal.ansiBrightBlue': colors.blue[400],
        'terminal.ansiBrightCyan': colors.cyan[400],
        'terminal.ansiBrightGreen': colors.green[400],
        'terminal.ansiBrightMagenta': colors.purple[400],
        'terminal.ansiBrightRed': colors.red[400],
        'terminal.ansiBrightWhite': colors.slate[300],
        'terminal.ansiBrightYellow': colors.yellow[500],
        'terminal.ansiCyan': colors.cyan[400],
        'terminal.ansiGreen': colors.green[400],
        'terminal.ansiMagenta': colors.purple[400],
        'terminal.ansiRed': colors.red[400],
        'terminal.ansiWhite': colors.slate[500],
        'terminal.ansiYellow': colors.yellow[500],
        'terminal.background': colors.slate[950],
        'terminal.foreground': colors.slate[500],
        'terminal.selectionBackground': `${colors.slate[600]}4d`,
        'textBlockQuote.background': colors.slate[950],
        'textCodeBlock.background': colors.slate[950],
        'textLink.activeForeground': colors.cyan[400],
        'textLink.foreground': colors.blue[400],
        'textPreformat.foreground': colors.slate[400],
        'textSeparator.foreground': colors.slate[600],
        'titleBar.activeBackground': colors.slate[950],
        'titleBar.activeForeground': colors.slate[500],
        'titleBar.border': colors.slate[900],
        'titleBar.inactiveBackground': colors.slate[950],
        'titleBar.inactiveForeground': colors.slate[500],
        'toolbar.activeBackground': colors.slate[800],
        'toolbar.hoverBackground': colors.slate[800],
        'tree.indentGuidesStroke': colors.slate[700],
        'walkThrough.embeddedEditorBackground': colors.slate[950],
        'widget.shadow': `${colors.white}00`,
        'window.activeBorder': colors.slate[900],
        'window.inactiveBorder': colors.slate[900],
    },
    displayName: 'Dark',
    name: 'dark',
    semanticTokenColors: {
        '*.defaultLibrary': {
            foreground: colors.cyan[500],
        },
        parameter: {
            foreground: colors.slate[200],
        },
        'parameter.declaration': {
            foreground: colors.yellow[500],
        },
        'property.declaration': {
            foreground: colors.green[400],
        },
        'property.defaultLibrary': {
            foreground: colors.cyan[500],
        },
        variable: {
            foreground: colors.slate[200],
        },
        'variable.declaration': {
            foreground: colors.purple[400],
        },
        'variable.defaultLibrary': {
            foreground: colors.cyan[500],
        },
    },
    tokenColors: [
        {
            scope: [
                'comment',
                'meta.var.expr storage.type',
                'keyword.control.flow',
                'keyword.control.return',
                'meta.directive.vue punctuation.separator.key-value.html',
                'meta.directive.vue entity.other.attribute-name.html',
                'tag.decorator.js entity.name.tag.js',
                'tag.decorator.js punctuation.definition.tag.js',
                'storage.modifier',
                'string.quoted.docstring.multi',
                'string.quoted.docstring.multi.python punctuation.definition.string.begin',
                'string.quoted.docstring.multi.python punctuation.definition.string.end',
                'string.quoted.docstring.multi.python constant.character.escape',
            ],
            settings: {
                fontStyle: 'italic',
            },
        },
        {
            scope: [
                'keyword.control.flow.block-scalar.literal',
                'keyword.control.flow.python',
            ],
            settings: {
                fontStyle: '',
            },
        },
        {
            scope: [
                'comment',
                'comment.block.documentation',
                'punctuation.definition.comment',
                'comment.block.documentation punctuation',
                'string.quoted.docstring.multi',
                'string.quoted.docstring.multi.python punctuation.definition.string.begin',
                'string.quoted.docstring.multi.python punctuation.definition.string.end',
                'string.quoted.docstring.multi.python constant.character.escape',
            ],
            settings: {
                foreground: colors.slate[600],
            },
        },
        {
            scope: [
                'keyword.operator.assignment.jsdoc',
                'comment.block.documentation variable',
                'comment.block.documentation storage',
                'comment.block.documentation keyword',
                'comment.block.documentation support',
                'comment.block.documentation markup',
                'comment.block.documentation markup.inline.raw.string.markdown',
                'meta.other.type.phpdoc.php keyword.other.type.php',
                'meta.other.type.phpdoc.php support.other.namespace.php',
                'meta.other.type.phpdoc.php punctuation.separator.inheritance.php',
                'meta.other.type.phpdoc.php support.class',
                'keyword.other.phpdoc.php',
                'log.date',
            ],
            settings: {
                foreground: colors.slate[500],
            },
        },
        {
            scope: [
                'meta.other.type.phpdoc.php support.class',
                'comment.block.documentation storage.type',
                'comment.block.documentation punctuation.definition.block.tag',
                'comment.block.documentation entity.name.type.instance',
            ],
            settings: {
                foreground: colors.slate[500],
            },
        },
        {
            scope: [
                'variable.other.constant',
                'punctuation.definition.constant',
                'constant.language',
                'constant.numeric',
                'support.constant',
                'constant.other.caps',
            ],
            settings: {
                foreground: colors.orange[400],
            },
        },
        {
            scope: [
                'string',
                'constant.other.symbol',
                'constant.other.key',
                'meta.attribute-selector',
                'string constant.character',
            ],
            settings: {
                fontStyle: '',
                foreground: colors.green[400],
            },
        },
        {
            scope: [
                'constant.other.color',
                'constant.other.color.rgb-value.hex punctuation.definition.constant',
            ],
            settings: {
                foreground: colors.slate[400],
            },
        },
        {
            scope: ['invalid', 'invalid.illegal'],
            settings: {
                foreground: colors.red[500],
            },
        },
        {
            scope: 'invalid.deprecated',
            settings: {
                foreground: colors.purple[400],
            },
        },
        {
            scope: 'storage.type',
            settings: {
                foreground: colors.purple[400],
            },
        },
        {
            scope: ['meta.var.expr storage.type', 'storage.modifier'],
            settings: {
                foreground: colors.purple[500],
            },
        },
        {
            scope: [
                'punctuation.definition.template-expression',
                'punctuation.section.embedded',
                'meta.embedded.line.tag.smarty',
                'support.constant.handlebars',
                'punctuation.section.tag.twig',
            ],
            settings: {
                foreground: colors.cyan[400],
            },
        },
        {
            scope: [
                'keyword.control.smarty',
                'keyword.control.twig',
                'support.constant.handlebars keyword.control',
                'keyword.operator.comparison.twig',
                'keyword.blade',
                'entity.name.function.blade',
                'meta.tag.blade keyword.other.type.php',
            ],
            settings: {
                foreground: colors.cyan[500],
            },
        },
        {
            scope: ['keyword.operator.spread', 'keyword.operator.rest'],
            settings: {
                fontStyle: 'bold',
                foreground: colors.red[400],
            },
        },
        {
            scope: [
                'keyword.operator',
                'keyword.control.as',
                'keyword.other',
                'keyword.operator.bitwise.shift',
                'punctuation',
                'expression.embbeded.vue punctuation.definition.tag',
                'text.html.twig meta.tag.inline.any.html',
                'meta.tag.template.value.twig meta.function.arguments.twig',
                'meta.directive.vue punctuation.separator.key-value.html',
                'punctuation.definition.constant.markdown',
                'punctuation.definition.string',
                'punctuation.support.type.property-name',
                'text.html.vue-html meta.tag',
                'meta.attribute.directive',
                'punctuation.definition.keyword',
                'punctuation.terminator.rule',
                'punctuation.definition.entity',
                'punctuation.separator.inheritance.php',
                'keyword.other.template',
                'keyword.other.substitution',
                'entity.name.operator',
                'meta.property-list punctuation.separator.key-value',
                'meta.at-rule.mixin punctuation.separator.key-value',
                'meta.at-rule.function variable.parameter.url',
                'meta.embedded.inline.phpx punctuation.definition.tag.begin.html',
                'meta.embedded.inline.phpx punctuation.definition.tag.end.html',
            ],
            settings: {
                foreground: colors.cyan[400],
            },
        },
        {
            scope: [
                'keyword.control.module.js',
                'keyword.control.import',
                'keyword.control.export',
                'keyword.control.from',
                'keyword.control.default',
                'meta.import keyword.other',
            ],
            settings: {
                foreground: colors.cyan[400],
            },
        },
        {
            scope: ['keyword', 'keyword.control', 'keyword.other.important'],
            settings: {
                foreground: colors.purple[400],
            },
        },
        {
            scope: 'keyword.other.DML',
            settings: {
                foreground: colors.cyan[400],
            },
        },
        {
            scope: [
                'keyword.operator.logical',
                'storage.type.function',
                'keyword.operator.bitwise',
                'keyword.operator.ternary',
                'keyword.operator.comparison',
                'keyword.operator.relational',
                'keyword.operator.or.regexp',
            ],
            settings: {
                foreground: colors.purple[400],
            },
        },
        {
            scope: 'entity.name.tag',
            settings: {
                foreground: colors.red[400],
            },
        },
        {
            scope: [
                'entity.name.tag support.class.component',
                'meta.tag.custom entity.name.tag',
                'meta.tag.other.unrecognized.html.derivative entity.name.tag',
                'meta.tag',
            ],
            settings: {
                foreground: colors.red[500],
            },
        },
        {
            scope: [
                'punctuation.definition.tag',
                'text.html.php meta.embedded.block.html meta.tag.metadata.script.end.html punctuation.definition.tag.begin.html text.html.basic',
            ],
            settings: {
                foreground: colors.purple[600],
            },
        },
        {
            scope: [
                'constant.other.php',
                'variable.other.global.safer',
                'variable.other.global.safer punctuation.definition.variable',
                'variable.other.global',
                'variable.other.global punctuation.definition.variable',
                'constant.other',
            ],
            settings: {
                foreground: colors.yellow[500],
            },
        },
        {
            scope: [
                'variable',
                'support.variable',
                'string constant.other.placeholder',
                'variable.parameter.handlebars',
                'variable.other.object',
                'meta.fstring',
                'meta.function-call meta.function-call.arguments',
                'meta.embedded.inline.phpx constant.other.php',
            ],
            settings: {
                foreground: colors.slate[200],
            },
        },
        {
            scope: 'meta.array.literal variable',
            settings: {
                foreground: colors.cyan[400],
            },
        },
        {
            scope: [
                'meta.object-literal.key',
                'entity.name.type.hcl',
                'string.alias.graphql',
                'string.unquoted.graphql',
                'string.unquoted.alias.graphql',
                'meta.group.braces.curly constant.other.object.key.js string.unquoted.label.js',
                'meta.field.declaration.ts variable.object.property',
                'meta.block entity.name.label',
            ],
            settings: {
                foreground: colors.green[400],
            },
        },
        {
            scope: [
                'variable.other.property',
                'support.variable.property',
                'support.variable.property.dom',
                'meta.function-call variable.other.object.property',
            ],
            settings: {
                foreground: colors.cyan[400],
            },
        },
        {
            scope: 'variable.other.object.property',
            settings: {
                foreground: colors.cyan[400],
            },
        },
        {
            scope: 'meta.objectliteral meta.object.member meta.objectliteral meta.object.member meta.objectliteral meta.object.member meta.object-literal.key',
            settings: {
                foreground: colors.cyan[600],
            },
        },
        {
            scope: 'source.cpp meta.block variable.other',
            settings: {
                foreground: colors.red[400],
            },
        },
        {
            scope: 'support.other.variable',
            settings: {
                foreground: colors.red[400],
            },
        },
        {
            scope: [
                'meta.class-method.js entity.name.function.js',
                'entity.name.method.js',
                'variable.function.constructor',
                'keyword.other.special-method',
                'storage.type.cs',
            ],
            settings: {
                foreground: colors.blue[400],
            },
        },
        {
            scope: [
                'entity.name.function',
                'variable.other.enummember',
                'meta.function-call',
                'meta.function-call entity.name.function',
                'variable.function',
                'meta.definition.method entity.name.function',
                'meta.object-literal entity.name.function',
            ],
            settings: {
                foreground: colors.blue[400],
            },
        },
        {
            scope: [
                'variable.parameter.function.language.special',
                'variable.parameter',
                'meta.function.parameters punctuation.definition.variable',
                'meta.function.parameter variable',
            ],
            settings: {
                foreground: colors.orange[400],
            },
        },
        {
            scope: [
                'keyword.other.type.php',
                'storage.type.php',
                'constant.character',
                'constant.escape',
                'keyword.other.unit',
            ],
            settings: {
                foreground: colors.purple[400],
            },
        },
        {
            scope: [
                'meta.definition.variable variable.other.constant',
                'meta.definition.variable variable.other.readwrite',
                'variable.declaration.hcl variable.other.readwrite.hcl',
                'meta.mapping.key.hcl variable.other.readwrite.hcl',
                'variable.other.declaration',
            ],
            settings: {
                foreground: colors.purple[400],
            },
        },
        {
            scope: 'entity.other.inherited-class',
            settings: {
                fontStyle: '',
                foreground: colors.purple[400],
            },
        },
        {
            scope: [
                'support.class',
                'support.type',
                'variable.other.readwrite.alias',
                'support.orther.namespace.use.php',
                'meta.use.php',
                'support.other.namespace.php',
                'support.type.sys-types',
                'support.variable.dom',
                'support.constant.math',
                'support.type.object.module',
                'support.constant.json',
                'entity.name.namespace',
                'meta.import.qualifier',
                'variable.other.constant.object',
            ],
            settings: {
                foreground: colors.cyan[400],
            },
        },
        {
            scope: 'entity.name',
            settings: {
                foreground: colors.cyan[400],
            },
        },
        {
            scope: 'support.function',
            settings: {
                foreground: colors.cyan[400],
            },
        },
        {
            scope: [
                'source.css support.type.property-name',
                'source.sass support.type.property-name',
                'source.scss support.type.property-name',
                'source.less support.type.property-name',
                'source.stylus support.type.property-name',
                'source.postcss support.type.property-name',
                'support.type.property-name.css',
                'support.type.vendored.property-name',
                'support.type.map.key',
            ],
            settings: {
                foreground: colors.cyan[400],
            },
        },
        {
            scope: ['support.constant.font-name', 'meta.definition.variable'],
            settings: {
                foreground: colors.green[400],
            },
        },
        {
            scope: [
                'entity.other.attribute-name.class',
                'meta.at-rule.mixin.scss entity.name.function.scss',
            ],
            settings: {
                foreground: colors.green[400],
            },
        },
        {
            scope: 'entity.other.attribute-name.id',
            settings: {
                foreground: colors.red[400],
            },
        },
        {
            scope: 'entity.name.tag.css',
            settings: {
                foreground: colors.cyan[400],
            },
        },
        {
            scope: [
                'entity.other.attribute-name.pseudo-class punctuation.definition.entity',
                'entity.other.attribute-name.pseudo-element punctuation.definition.entity',
                'entity.other.attribute-name.class punctuation.definition.entity',
                'entity.name.tag.reference',
            ],
            settings: {
                foreground: colors.orange[400],
            },
        },
        {
            scope: 'meta.property-list',
            settings: {
                foreground: colors.blue[300],
            },
        },
        {
            scope: [
                'meta.property-list meta.at-rule.if',
                'meta.at-rule.return variable.parameter.url',
                'meta.property-list meta.at-rule.else',
            ],
            settings: {
                foreground: colors.orange[400],
            },
        },
        {
            scope: [
                'entity.other.attribute-name.parent-selector-suffix punctuation.definition.entity.css',
            ],
            settings: {
                foreground: colors.green[400],
            },
        },
        {
            scope: 'meta.property-list meta.property-list',
            settings: {
                foreground: colors.blue[300],
            },
        },
        {
            scope: [
                'meta.at-rule.mixin keyword.control.at-rule.mixin',
                'meta.at-rule.include entity.name.function.scss',
                'meta.at-rule.include keyword.control.at-rule.include',
            ],
            settings: {
                foreground: colors.purple[400],
            },
        },
        {
            scope: [
                'keyword.control.at-rule.include punctuation.definition.keyword',
                'keyword.control.at-rule.mixin punctuation.definition.keyword',
                'meta.at-rule.include keyword.control.at-rule.include',
                'keyword.control.at-rule.extend punctuation.definition.keyword',
                'meta.at-rule.extend keyword.control.at-rule.extend',
                'entity.other.attribute-name.placeholder.css punctuation.definition.entity.css',
                'meta.at-rule.media keyword.control.at-rule.media',
                'meta.at-rule.mixin keyword.control.at-rule.mixin',
                'meta.at-rule.function keyword.control.at-rule.function',
                'keyword.control punctuation.definition.keyword',
            ],
            settings: {
                foreground: colors.purple[500],
            },
        },
        {
            scope: 'meta.property-list meta.at-rule.include',
            settings: {
                foreground: colors.cyan[400],
            },
        },
        {
            scope: 'support.constant.property-value',
            settings: {
                foreground: colors.orange[400],
            },
        },
        {
            scope: [
                'entity.name.module.js',
                'variable.import.parameter.js',
                'variable.other.class.js',
            ],
            settings: {
                foreground: colors.cyan[400],
            },
        },
        {
            scope: 'variable.language',
            settings: {
                foreground: colors.red[400],
            },
        },
        {
            scope: 'variable.other punctuation.definition.variable',
            settings: {
                foreground: colors.cyan[400],
            },
        },
        {
            scope: [
                'source.js constant.other.object.key.js string.unquoted.label.js',
                'variable.language.this punctuation.definition.variable',
                'keyword.other.this',
            ],
            settings: {
                foreground: colors.red[400],
            },
        },
        {
            scope: [
                'entity.other.attribute-name',
                'text.html.basic entity.other.attribute-name.html',
                'text.html.basic entity.other.attribute-name',
            ],
            settings: {
                foreground: colors.purple[400],
            },
        },
        {
            scope: 'text.html constant.character.entity',
            settings: {
                foreground: colors.cyan[400],
            },
        },
        {
            scope: [
                'entity.other.attribute-name.id.html',
                'meta.directive.vue entity.other.attribute-name.html',
            ],
            settings: {
                foreground: colors.purple[400],
            },
        },
        {
            scope: 'source.sass keyword.control',
            settings: {
                foreground: colors.blue[400],
            },
        },
        {
            scope: [
                'entity.other.attribute-name.pseudo-class',
                'entity.other.attribute-name.pseudo-element',
                'entity.other.attribute-name.placeholder',
                'meta.property-list meta.property-value',
            ],
            settings: {
                foreground: colors.purple[400],
            },
        },
        {
            scope: 'markup.inserted',
            settings: {
                foreground: colors.cyan[600],
            },
        },
        {
            scope: 'markup.deleted',
            settings: {
                foreground: colors.red[700],
            },
        },
        {
            scope: 'markup.changed',
            settings: {
                foreground: colors.blue[600],
            },
        },
        {
            scope: 'string.regexp',
            settings: {
                foreground: colors.cyan[300],
            },
        },
        {
            scope: 'punctuation.definition.group',
            settings: {
                foreground: colors.red[400],
            },
        },
        {
            scope: ['constant.other.character-class.regexp'],
            settings: {
                foreground: colors.purple[400],
            },
        },
        {
            scope: [
                'constant.other.character-class.set.regexp',
                'punctuation.definition.character-class.regexp',
            ],
            settings: {
                foreground: colors.orange[400],
            },
        },
        {
            scope: 'keyword.operator.quantifier.regexp',
            settings: {
                foreground: colors.cyan[400],
            },
        },
        {
            scope: 'constant.character.escape.backslash',
            settings: {
                foreground: colors.cyan[400],
            },
        },
        {
            scope: 'constant.character.escape',
            settings: {
                foreground: colors.cyan[400],
            },
        },
        {
            scope: [
                'tag.decorator.js entity.name.tag.js',
                'tag.decorator.js punctuation.definition.tag.js',
            ],
            settings: {
                foreground: colors.blue[400],
            },
        },
        {
            scope: 'keyword.other.unit',
            settings: {
                foreground: colors.red[400],
            },
        },
        {
            scope: [
                'source.json meta.structure.dictionary.json support.type.property-name.json',
            ],
            settings: {
                foreground: colors.cyan[400],
            },
        },
        {
            scope: [
                'source.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json support.type.property-name.json',
            ],
            settings: {
                foreground: colors.cyan[400],
            },
        },
        {
            scope: [
                'source.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json support.type.property-name.json',
            ],
            settings: {
                foreground: colors.cyan[400],
            },
        },
        {
            scope: [
                'source.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json support.type.property-name.json',
            ],
            settings: {
                foreground: colors.purple[400],
            },
        },
        {
            scope: [
                'source.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json support.type.property-name.json',
            ],
            settings: {
                foreground: colors.orange[400],
            },
        },
        {
            scope: [
                'source.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json support.type.property-name.json',
            ],
            settings: {
                foreground: colors.cyan[400],
            },
        },
        {
            scope: [
                'source.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json support.type.property-name.json',
            ],
            settings: {
                foreground: colors.purple[400],
            },
        },
        {
            scope: [
                'source.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json support.type.property-name.json',
            ],
            settings: {
                foreground: colors.orange[400],
            },
        },
        {
            scope: [
                'source.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json support.type.property-name.json',
            ],
            settings: {
                foreground: colors.cyan[400],
            },
        },
        {
            scope: [
                'source.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json meta.structure.dictionary.value.json meta.structure.dictionary.json support.type.property-name.json',
            ],
            settings: {
                foreground: colors.purple[400],
            },
        },
        {
            scope: 'punctuation.definition.list_item.markdown',
            settings: {
                foreground: colors.blue[300],
            },
        },
        {
            scope: [
                'meta.block',
                'meta.brace',
                'punctuation.definition.block',
                'punctuation.definition.use',
                'punctuation.definition.class',
                'punctuation.definition.begin.bracket',
                'punctuation.definition.end.bracket',
                'punctuation.definition.switch-expression.begin.bracket',
                'punctuation.definition.switch-expression.end.bracket',
                'punctuation.definition.section.switch-block.begin.bracket',
                'punctuation.definition.section.switch-block.end.bracket',
                'punctuation.definition.group.shell',
                'punctuation.definition.parameters',
                'punctuation.definition.arguments',
                'punctuation.definition.dictionary',
                'punctuation.definition.array',
                'punctuation.section',
            ],
            settings: {
                foreground: colors.blue[300],
            },
        },
        {
            scope: ['meta.embedded.block'],
            settings: {
                foreground: colors.cyan[400],
            },
        },
        {
            scope: [
                'meta.tag JSXNested',
                'meta.jsx.children',
                'text.html',
                'text.log',
            ],
            settings: {
                foreground: colors.purple[400],
            },
        },
        {
            scope: 'text.html.markdown markup.inline.raw.markdown',
            settings: {
                foreground: colors.purple[400],
            },
        },
        {
            scope: 'text.html.markdown markup.inline.raw.markdown punctuation.definition.raw.markdown',
            settings: {
                foreground: colors.slate[600],
            },
        },
        {
            scope: [
                'heading.1.markdown entity.name',
                'heading.1.markdown punctuation.definition.heading.markdown',
            ],
            settings: {
                fontStyle: 'bold',
                foreground: colors.cyan[400],
            },
        },
        {
            scope: [
                'heading.2.markdown entity.name',
                'heading.2.markdown punctuation.definition.heading.markdown',
            ],
            settings: {
                fontStyle: 'bold',
                foreground: colors.blue[400],
            },
        },
        {
            scope: [
                'heading.3.markdown entity.name',
                'heading.3.markdown punctuation.definition.heading.markdown',
            ],
            settings: {
                fontStyle: 'bold',
                foreground: colors.blue[400],
            },
        },
        {
            scope: [
                'heading.4.markdown entity.name',
                'heading.4.markdown punctuation.definition.heading.markdown',
            ],
            settings: {
                fontStyle: 'bold',
                foreground: colors.blue[500],
            },
        },
        {
            scope: [
                'heading.5.markdown entity.name',
                'heading.5.markdown punctuation.definition.heading.markdown',
            ],
            settings: {
                fontStyle: 'bold',
                foreground: colors.purple[400],
            },
        },
        {
            scope: [
                'heading.6.markdown entity.name',
                'heading.6.markdown punctuation.definition.heading.markdown',
            ],
            settings: {
                fontStyle: 'bold',
                foreground: colors.slate[500],
            },
        },
        {
            scope: ['markup.italic', 'markup.italic punctuation'],
            settings: {
                fontStyle: 'italic',
                foreground: colors.cyan[400],
            },
        },
        {
            scope: ['markup.bold', 'markup.bold punctuation'],
            settings: {
                fontStyle: 'bold',
                foreground: colors.cyan[400],
            },
        },
        {
            scope: [
                'markup.bold markup.italic',
                'markup.bold markup.italic punctuation',
            ],
            settings: {
                fontStyle: 'bold italic',
                foreground: colors.slate[200],
            },
        },
        {
            scope: ['markup.underline', 'markup.underline punctuation'],
            settings: {
                fontStyle: 'underline',
            },
        },
        {
            scope: 'markup.quote punctuation.definition.blockquote.markdown',
            settings: {
                foreground: colors.slate[600],
            },
        },
        {
            scope: 'markup.quote',
            settings: {
                fontStyle: 'italic',
            },
        },
        {
            scope: [
                'string.other.link',
                'markup.underline.link',
                'constant.other.reference.link.markdown',
                'string.other.link.description.title.markdown',
            ],
            settings: {
                foreground: colors.green[400],
            },
        },
        {
            scope: [
                'markup.fenced_code.block.markdown',
                'markup.inline.raw.string.markdown',
                'variable.language.fenced.markdown',
            ],
            settings: {
                foreground: colors.cyan[400],
            },
        },
        {
            scope: 'meta.separator',
            settings: {
                fontStyle: 'bold',
                foreground: colors.slate[600],
            },
        },
        {
            scope: 'markup.table',
            settings: {
                foreground: colors.slate[200],
            },
        },
        {
            scope: 'token.info-token',
            settings: {
                foreground: colors.cyan[500],
            },
        },
        {
            scope: 'token.warn-token',
            settings: {
                foreground: colors.yellow[400],
            },
        },
        {
            scope: 'token.error-token',
            settings: {
                foreground: colors.red[500],
            },
        },
        {
            scope: 'token.debug-token',
            settings: {
                foreground: colors.purple[500],
            },
        },
        {
            scope: 'entity.tag.apacheconf',
            settings: {
                foreground: colors.red[400],
            },
        },
        {
            scope: ['meta.preprocessor'],
            settings: {
                foreground: colors.green[400],
            },
        },
        {
            scope: 'source.env',
            settings: {
                foreground: colors.blue[400],
            },
        },
    ],
    type: 'dark',
};
